/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const MailForwardIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M8.002,15.5 L2,15.5 C1.172,15.5 0.5,14.828 0.5,14 L0.5,3 C0.5,2.172 1.172,1.5 2,1.5 L20,1.5 C20.828,1.5 21.5,2.172 21.5,3 L21.5,9.063" />
      <polyline points="21 2 11 10 1 2" />
      <polygon points="17.5 18.5 17.5 21.5 23.5 16 17.5 10.5 17.5 13.5 10.5 13.5 10.5 18.5" />
    </g>
  </svg>
);

export default MailForwardIcon;
